export default function DynamicHeading(props: { heading: string, fallback: string } & any) {
    const {heading, fallback} = props;

    if (heading === 'h1' || fallback === 'h1') {
        return <h1 {...props}>{props.children}</h1>
    }

    if (heading === 'h3'  || fallback === 'h3') {
        return <h3 {...props}>{props.children}</h3>
    }
    if (heading === 'h4'  || fallback === 'h4') {
        return <h4 {...props}>{props.children}</h4>
    }
    if (heading === 'h5'  || fallback === 'h5') {
        return <h5 {...props}>{props.children}</h5>
    }

    if (heading === 'p'  || fallback === 'p') {
        return <p {...props}>{props.children}</p>
    }


    // Default
    return <h2 {...props}>{props.children}</h2>

}